// components/SmoothScrollWrapper.jsx
import React, { useEffect, useRef } from 'react';
import Lenis from '@studio-freight/lenis';
import { useLocation } from 'react-router-dom';
import { useMobileDetection } from '../hooks/useMobileDetection';

const SmoothScrollWrapper = ({ children }) => {
    const { isMobile } = useMobileDetection();
    const lenisRef = useRef(null);
    const location = useLocation();
    const initRef = useRef(false);

    useEffect(() => {
        // Skip Lenis initialization on mobile devices
        if (isMobile) {
            // Set window.lenis to null for mobile so other components know
            window.lenis = null;
            return;
        }

        // Initialize Lenis function - existing logic unchanged
        const initLenis = () => {
            if (lenisRef.current) return;

            lenisRef.current = new Lenis({
                duration: 1.5,
                easing: (t) => 1 - Math.pow(1 - t, 5),
                orientation: 'vertical',
                gestureOrientation: 'vertical',
                smoothWheel: true,
                wheelMultiplier: 0.8,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false,
                lerp: 0.08,
            });

            function raf(time) {
                lenisRef.current?.raf(time);
                requestAnimationFrame(raf);
            }

            requestAnimationFrame(raf);
            window.lenis = lenisRef.current;
            initRef.current = true;
        };

        initLenis();

        return () => {
            // Keep existing cleanup logic
        };
    }, [isMobile]);

    // Reset scroll position on navigation - only if not mobile
    useEffect(() => {
        if (!isMobile && lenisRef.current) {
            lenisRef.current.scrollTo(0, { immediate: true });
            lenisRef.current.start();
        } else if (isMobile) {
            // Use native scroll for mobile
            window.scrollTo(0, 0);
        }
    }, [location.pathname, isMobile]);

    return children;
};

export default SmoothScrollWrapper;